export default "__VITE_ASSET__fa506016__"